import React from 'react'

const useGetAbsElementPosition = refElement => {
	const [absPosition, setAbsPosition] = React.useState({
		x: '',
		y: '',
		top: '',
		left: '',
		bottom: '',
		right: ''
	})
	React.useEffect(() => {
		const rect = refElement.current.getBoundingClientRect()
		setAbsPosition({
			x: rect.x,
			y: rect.y,
			top: rect.top,
			left: rect.left,
			bottom: rect.bottom,
			right: rect.right,
			width: rect.width,
			height: rect.height
		})
	}, [refElement])

	return { absPosition }
}
export default useGetAbsElementPosition
